import { render, staticRenderFns } from "./display-text-data.vue?vue&type=template&id=4b43e72a&scoped=true&"
import script from "./display-text-data.vue?vue&type=script&lang=js&"
export * from "./display-text-data.vue?vue&type=script&lang=js&"
import style0 from "./display-text-data.vue?vue&type=style&index=0&id=4b43e72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43e72a",
  null
  
)

export default component.exports